<template>
  <div class="confirm-booking-modal">
    <div class="confirm-booking">
      <div
        data-w-id="053ad83e-9368-e7f9-b94d-6cf10a856689"
        class="link-block-5 w-inline-block"
        @click="cancel"
      >
        <img src="@/assets/timeslot-images/cancel.svg" loading="lazy" alt="" />
      </div>
      <div class="div-block-52-copy">
        <h1 class="modal-heading">Confirm your booking</h1>
      </div>

      <p class="paragraph-7-copy">
        Consultation with
        <a href="#" class="link-10">{{ singleProfessional.customerName }}</a>
      </p>
      <div class="div-block-80">
        <div class="div-block-82">
          <div class="div-block-81">
            <img
              src="@/assets/timeslot-images/calendar1.svg"
              loading="lazy"
              alt=""
              class="image-17"
            />
            <div class="text-block-67">
              {{ formatDate(new Date(selectedDate)) }}
            </div>
          </div>
          <div class="div-block-81">
            <img
              src="@/assets/timeslot-images/clock1.svg"
              loading="lazy"
              alt=""
              class="image-17"
            />
            <div class="text-block-67">
              {{
                formatHours(new Date(selectedSlot.availableTimeStartTime))
              }}:{{
                formatMinutes(new Date(selectedSlot.availableTimeStartTime))
              }}
              -
              {{ formatHours(new Date(selectedSlot.availableTimeEndTime)) }}:{{
                formatMinutes(new Date(selectedSlot.availableTimeEndTime))
              }}
              {{ formatTime(new Date(selectedSlot.availableTimeEndTime)) }}

              ({{ customerInfo.customerTimezone }})
            </div>
          </div>
        </div>
        <div>
          <div class="div-block-81">
            <img
              src="@/assets/timeslot-images/price.svg"
              loading="lazy"
              alt=""
              class="image-17"
            />
            <div class="text-block-67">{{ amount }} USD</div>
          </div>
        </div>
      </div>
      <div class="div-block-83">
        <div class="div-block-84">
          <div class="text-block-68">Enter topic</div>
          <input
            type="text"
            class="text-field-3 w-input"
            maxlength="256"
            name="field-3"
            data-name="Field 3"
            placeholder="e.g Managing burnout"
            id="field-3"
            required=""
            v-model="confirmModel.bookingTopic"
          />
        </div>
        <div>
          <div class="text-block-68">Enter description</div>
          <textarea
            placeholder="Add a description"
            maxlength="5000"
            id="field-2"
            name="field-2"
            data-name="field"
            class="textarea w-input"
            v-model="confirmModel.bookingMessage"
          ></textarea>
        </div>
      </div>
      <BaseComponentLoader
        v-if="loader.nonBlockingLoader"
        loaderAlignment="center"
      />
      <div
        data-w-id="053ad83e-9368-e7f9-b94d-6cf10a856698"
        class="button-15 w-button"
        @click="createBooking"
        v-else
      >
        Confirm booking
      </div>
      <div class="button-15-copy w-button" @click="change">
        Change date & time
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import BookingRequest from "@/model/requests/BookingRequest";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import BaseComponentLoader from "@/components/BaseComponents/BaseComponentLoader";

export default {
  name: "ConfirmBookingModal",
  components: {
    BaseComponentLoader
  },
  data() {
    return {
      confirmModel: BookingRequest.create
    };
  },
  props: {
    cancel: Function,
    change: Function
  },
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      professionalInfo: state => state.professional.professionalInfo,
      singleProfessional: state => state.professional.singleProfessional,
      selectedDate: state => state.availability.selectedDate,
      selectedTimeSlots: state => state.availability.selectedTimeSlots,
      selectedSlot: state => state.availability.selectedSlot,
      customerInfo: state => state.customer.customerInfo
    }),
    amount() {
      return this.singleProfessional.professionalBookingFee;
    },
    ...mapState(["loader"])
  },
  methods: {
    formatDate(date) {
      return moment(date).format("ll");
    },
    formatTime(date) {
      return moment(date).format("a");
    },
    formatMinutes(date) {
      return moment(date).format("mm");
    },
    formatHours(date) {
      return moment(date).format("h");
    },
    createBooking() {
      this.confirmModel.bookingCustomerId = this.userInfo.customerId;
      this.confirmModel.bookingProfessionalId = this.singleProfessional.professionalId;
      this.confirmModel.bookingAmount = this.amount;
      this.confirmModel.bookingAvailableTime = this.selectedSlot.availableTimeId;
      StoreUtils.dispatch("booking/createBooking", this.confirmModel).then(
        response => {
          let responseCode = response.responseCode;
          if (responseCode === "00") {
            StoreUtils.commit("booking/updateBookingSuccess", true);
          } else {
            StoreUtils.commit("booking/updateBookingSuccess", false);
          }
        }
      );
    },
    shortTimezone(value) {
      let timeStrings = value.split(" ");
      let newList = timeStrings.map(item => item[0]).join("");
      return newList;
    }
  }
};
</script>

<style scoped></style>
